<template>
  <div class="spinner__cover" v-if="showSpinner">
    <div class="">
      <div class="sk-chase" v-if="!spinnerIcon || spinnerIcon === 'loading'">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div
        class="spinner__icon text-danger text-center"
        v-if="spinnerIcon === 'error'"
      >
        <i class="far fa-times-circle"></i>
      </div>

      <div
        class="spinner__icon text-success text-center"
        v-if="spinnerIcon === 'success'"
      >
        <i class="far fa-check-circle"></i>
      </div>

      <p class="text-center text-light mt-5" v-if="spinnerMessage">
        {{ spinnerMessage }}
      </p>
      <div
        class="col-12 d-flex justify-content-center"
        v-if="spinnerIcon === 'success'"
      >
        <button class="btn btn-light" @click="closeSpinner">Aceptar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeSpinner() {
      this.$store.state.showSpinner = false;
      this.$store.state.spinnerIcon = "loading"
      this.$emit("onAccept")
    },
  },
  computed: {
    showSpinner() {
      return this.$store.state.showSpinner;
    },
    spinnerMessage() {
      return this.$store.state.spinnerMessage;
    },
    spinnerIcon() {
      return this.$store.state.spinnerIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner__icon i {
  font-size: 50px;
}
</style>